module.exports = {
    listPageScrollTop: 0,
    careerTalkPosition: null, // 宣讲会当前投递职位
    seesionDetail: null // 宣讲会详情
}



// WEBPACK FOOTER //
// ./src/store/positionList/state.js